/**
 * This package's translations, registered at import.
 *
 * French and English only, unlike the socle's features which carry four
 * locales. The product is French — §6 of `docs/product/cadrage-hardauto.md` —
 * and English is here because it is the parity reference and i18next's
 * fallback. Shipping machine-made Spanish and Arabic for 200 domain terms
 * ("encours", "barème", "dépôt de rattachement") would look like support and
 * behave like noise.
 */

import { registerNamespace } from "@hardauto/core-i18n";

import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const NAMESPACE = "referential";

registerNamespace(NAMESPACE, { en, fr });
